import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=acbc31ea&scoped=true&"
import script from "./SideMenu.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=acbc31ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbc31ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acbc31ea')) {
      api.createRecord('acbc31ea', component.options)
    } else {
      api.reload('acbc31ea', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=acbc31ea&scoped=true&", function () {
      api.rerender('acbc31ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenu.vue"
export default component.exports